import { render, staticRenderFns } from "./table-column2.vue?vue&type=template&id=0f6d29f1&lang=pug&"
import script from "./table-column2.vue?vue&type=script&lang=js&"
export * from "./table-column2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports